import React from 'react';
import { ButtonDatumType } from '../types';
import './Button.css';

type ButtonType = {
  link?: string;
  callback?: (() => void) | null;
  buttonData: ButtonDatumType;
  isDisabled?: boolean;
};

const Button = ({
  link,
  callback,
  buttonData: {
    label,
    backgroundColor = 'darkgray',
    color = 'white',
  },
  isDisabled = false,
}: ButtonType) => {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (callback) {
      callback();
    } else if (link) {
      window.open(link, '_blank', 'noopener,noreferrer');
    }
  };

  const className = `Button ${isDisabled ? 'inactive' : 'active'}`;
  const style = {
    color: isDisabled ? 'white' : color,
    backgroundColor: isDisabled ? 'lightgray' : backgroundColor,
    borderColor: isDisabled ? 'lightgray' : backgroundColor,
    boxShadow: isDisabled ? '0' : '1px 2px #888888',
  };

  return (
    <button
      className={ className }
      onClick={ handleClick }
      style={ style }
      disabled={ isDisabled }
      type='button'
    >
      { label }
    </button>
  );
};

export default Button;
